import React from "react";

import { Select } from "antd";

export default function FilterDropdown({
  label,
  options = [],
  defaultValue,
  value,
  onSelect,
  onClear,
  withSearch = false,
  allowClear,
}) {
  const Label = <label>{label}</label>;

  if (withSearch) {
    return (
      <div className="SendReports__DropdownContainer">
        {Label}
        <Select
          className="SendReports__ActionSelect"
          popupClassName="SendReports__ActionSelect__Menu"
          showSearch
          options={options}
          onSelect={onSelect}
          value={value}
          defaultValue={options[0]?.value}
          listHeight={200}
          allowClear={allowClear}
          onClear={onClear}
          filterOption={(inputValue, option) => option.label?.toLowerCase().includes(inputValue?.toLowerCase())}
        />
      </div>
    );
  }

  return (
    <div className="SendReports__DropdownContainer">
      {Label}
      <Select
        allowClear={allowClear}
        className="SendReports__ActionSelect"
        popupClassName="SendReports__ActionSelect__Menu"
        defaultValue={defaultValue}
        value={value}
        options={options}
        onSelect={onSelect}
        onClear={onClear}
      />
    </div>
  );
}
